import React from 'react';
import styled from 'styled-components';

import { ColorVariantEnum, MarginSizeEnum, Text } from '../../atoms/text';
import { theme } from '../../theme';

interface IStyledSwitch {
	isChecked: boolean;
	isDisabled?: boolean;
}

interface ISwitch extends IStyledSwitch {
	dataTestId?: string;
	text?: string;
	width?: string | number;
	onClick: (value?: boolean) => void;
}

interface IStyledLabel extends IStyledSwitch {
	width?: string | number;
}
interface IStyledCircleSwitch {
	isChecked: boolean;
}

const StyledLabel = styled.label<IStyledLabel>`
	display: inline-flex;
	align-items: center;
	width: ${(props) => props.width || '100%'};
	justify-content: space-between;
	cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
	:hover {
		.styled-circle-switch {
			height: 14px;
			width: 14px;
		}
	}
`;

const StyledSwitch = styled.div<IStyledSwitch>`
	position: relative;
	width: 34px;
	height: 20px;
	cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};
	border-radius: 10px;
	background-color: ${(props) =>
		props.isDisabled
			? theme.colors.switch.background.disabled
			: props.isChecked
			? theme.colors.switch.background.checked
			: theme.colors.switch.background.default};
`;

const StyledInput = styled.input`
	opacity: 0;
	width: 0;
	height: 0;
`;

const StyledCircleSwitch = styled.div<IStyledCircleSwitch>`
	position: absolute;
	top: 50%;
	left: ${(props) => (props.isChecked ? '16px' : '4px')};
	transform: translateY(-50%);
	background-color: ${theme.colors.switch.icon};
	border-radius: 50%;
	height: 12px;
	width: 12px;
	transition: all 300ms ease-out;
`;

export const Switch = ({ text, dataTestId, width, isChecked, isDisabled, onClick }: ISwitch) => {
	return (
		<StyledLabel isChecked={isChecked} isDisabled={isDisabled} width={width}>
			{text && (
				<Text.Paragraph
					colorVariant={
						isDisabled ? ColorVariantEnum.DISABLED : isChecked ? ColorVariantEnum.DARK : ColorVariantEnum.MEDIUM
					}
					margin={MarginSizeEnum.NONE}
				>
					{text}
				</Text.Paragraph>
			)}
			<StyledInput
				type="switch"
				name="switch"
				checked={isChecked}
				onClick={() => onClick(!isChecked)}
				data-testid={dataTestId}
			/>
			<StyledSwitch isChecked={isChecked} isDisabled={isDisabled}>
				<StyledCircleSwitch isChecked={isChecked} className="styled-circle-switch" />
			</StyledSwitch>
		</StyledLabel>
	);
};
